import React from 'react'
import Head from 'next/head'
import Pitch from '@src/components/DisposalPage/Pitch'
import FeatureList from '@src/components/DisposalPage/FeatureList'
import Approach from '@src/components/DisposalPage/Approach'
import FAQ from '@src/components/DisposalPage/FAQ'
import SustainabilityDashboardPromo from '@src/components/DisposalPage/SustainabilityDashboardPromo'
import SchemaMarkup from '@src/components/SchemaMarkup'
import RelatedServices from '@src/components/RelatedServices'
import Clients from '@src/pages/LandingPage/Clients'
import TrustBox from '@src/pages/common/components/TrustBox'
import TrustedByClients from '@src/components/DisposalPage/TrustedByClients'
import pageClasses from '@src/styles/milk-dairy-disposal-page.module.css'
// eslint-disable-next-line import/extensions
import milk from '../../json/milk-dairy-disposal-data.json'

const milkServiceData = {
  name: 'Milk and Dairy Disposal',
  description:
    'Sustainable milk and dairy disposal nationwide. Dimension recycles expired milk, yogurt, whey, and protein drinks through lactose reclamation, recycles coated-paper cartons, and provides full documentation.',
  serviceType: 'Milk and Dairy Disposal',
  url: 'https://getdimension.com/milk-dairy-disposal',
  provider: {
    name: 'Dimension',
    url: 'https://getdimension.com',
    address: {
      streetAddress: '2261 Market Street, #4061',
      addressLocality: 'San Francisco',
      addressRegion: 'CA',
      postalCode: '94114',
      addressCountry: 'US',
    },
    telephone: '+1 (415) 340-7182',
  },
  offers: [
    { name: 'Milk Disposal and Recycling' },
    { name: 'Yogurt and Dairy Drink Disposal' },
    { name: 'Whey and Protein Shake Disposal' },
    { name: 'Milk Carton Recycling' },
    { name: 'Lactose Reclamation' },
  ],
}

const milkFAQData = {
  questions: milk.FAQContent.contentList.map((faq) => ({
    question: faq.heading.replace(/<[^>]*>/g, ''),
    answer: faq.textList.join(' '),
  })),
}

function MilkDairyDisposal() {
  return (
    <>
      <Head>
        <title>Milk &amp; Dairy Disposal and Recycling | Dimension</title>
        <meta
          name="description"
          content="Sustainable milk and dairy disposal nationwide. Dimension recycles expired milk, yogurt, whey, and protein drinks through lactose reclamation and recycles cartons. Cased pricing from ~$0.83/case."
        />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="canonical" href="https://getdimension.com/milk-dairy-disposal" />
        <SchemaMarkup type="WebSite" />
        <SchemaMarkup type="Service" data={milkServiceData} />
        <SchemaMarkup type="FAQPage" data={milkFAQData} />
        <SchemaMarkup type="LocalBusiness" />
      </Head>
      <div className={pageClasses.root}>
        <Pitch
          variant="hazardous-waste"
          heroImage="beverage"
          heading={milk.pitch.heading}
          material={milk.pitch.material}
          pitchText={milk.pitch.pitchText}
          ctaLink={milk.pitch.ctaLink}
          ctaText={milk.pitch.ctaText}
          belowCta={<TrustBox isMobile isDark={false} />}
          belowPitch={<TrustedByClients />}
        />
        <Clients />
        <FeatureList {...milk.solutions} />
        <SustainabilityDashboardPromo />
        <FeatureList {...milk.benefits} />
        <Approach {...milk.approach} />
        <FAQ {...milk.FAQContent} />
        <RelatedServices
          services={[
            {
              label: 'Beverage Disposal Services',
              href: '/beverage-disposal',
              description:
                'Nationwide recycling of expired and surplus beverages of every kind through ethanol reclamation.',
            },
            {
              label: 'Sugary Beverage Disposal',
              href: '/sugary-beverage-disposal',
              description:
                'Recycling of expired sodas, juices, and energy drinks through ethanol reclamation.',
            },
            {
              label: 'Alcoholic Beverage Disposal',
              href: '/alcoholic-beverage-disposal',
              description:
                'Compliant destruction and recycling of beer, wine, spirits, and other alcoholic beverages.',
            },
            {
              label: 'Sustainable Solutions',
              href: '/sustainability',
              description:
                'See how Dimension diverts waste from landfills and reports the impact for your business.',
            },
          ]}
        />
      </div>
    </>
  )
}

export default MilkDairyDisposal
